export enum ServiceType {
  AgentApi = "AgentApi",
  Autofiling = "Autofiling",
  Bff = "Bff",
  Dashboard = "Dashboard",
  DocumentAdministration = "DocumentAdministration",
  FileManagement = "FileManagement",
  FileStorage = "FileStorage",
  InternalAdmin = "InternalAdmin",
  MasterData = "MasterData",
  Notification = "Notification",
  PortalAdmin = "PortalAdmin",
  Portal = "Portal",
  UserManagement = "UserManagement",
  Wopi = "Wopi",
}
